var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.798,
    height: 32.513,
    viewBox: "0 0 31.798 32.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12033",
    "data-name": "Path 12033",
    d: "M27.973,18.47a12.243,12.243,0,0,0,.094-1.463,9.252,9.252,0,0,0-.113-1.463l3.17-2.476a.775.775,0,0,0,.188-.957l-3-5.2a.763.763,0,0,0-.919-.338l-3.733,1.5a10.99,10.99,0,0,0-2.532-1.463l-.563-3.977A.749.749,0,0,0,19.813,2h-6a.73.73,0,0,0-.732.638l-.563,3.977A11.284,11.284,0,0,0,9.984,8.078l-3.733-1.5a.742.742,0,0,0-.919.338l-3,5.2a.727.727,0,0,0,.188.957l3.17,2.476a8.84,8.84,0,0,0-.019,2.926L2.5,20.946a.775.775,0,0,0-.188.957l3,5.2a.763.763,0,0,0,.919.338l3.733-1.5A10.99,10.99,0,0,0,12.5,27.4l.563,3.977a.763.763,0,0,0,.75.638h6a.717.717,0,0,0,.732-.638l.563-3.977a11.284,11.284,0,0,0,2.532-1.463l3.733,1.5a.742.742,0,0,0,.919-.338l3-5.2a.727.727,0,0,0-.188-.957L27.973,18.47ZM16.812,22.634a5.627,5.627,0,1,1,5.627-5.627A5.644,5.644,0,0,1,16.812,22.634Z",
    transform: "translate(-0.913 -0.75)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.c8210391d990ec4098ec9805ae8b0a5f.svg";
export { ForwardRef as ReactComponent };